<script setup lang="ts">
/* UTILS */
import { computed } from "vue"
import { useRoute } from "vue-router"

/* STORES */
import { useAnswersStore as useShapeAnswersStore } from "@/features/shape/store/answers.store"
import { useAnswersStore as useSwipeAnswersStore } from "@/features/swipe/store/answers.store"
import { useAnswersStore as useDriveAnswersStore } from "@/features/drive/store/answers.store"
import { useAnswersStore as useBrainAnswersStore } from "@/features/brain/stores/answers.store"
import { useAnswersStore as useMoveAnswersStore } from "@/features/move/store/answers.store"

const {
  patchFactoryTest: patchShapeFactoryTest,
  resetUserDataLight: resetShape,
} = useShapeAnswersStore()
const {
  patchFactoryTest: patchSwipeFactoryTest,
  resetUserDataLight: resetSwipe,
} = useSwipeAnswersStore()
const {
  patchFactoryTest: patchDriveFactoryTest,
  resetUserDataLight: resetDrive,
} = useDriveAnswersStore()
const {
  patchFactoryTest: patchBrainFactoryTest,
  resetUserDataLight: resetBrain,
} = useBrainAnswersStore()
const {
  patchFactoryTest: patchMoveFactoryTest,
  resetUserDataLight: resetMove,
} = useMoveAnswersStore()

const route = useRoute()
const path = computed(() => route.path)

const handleFactoryTest = (isRestarting: boolean) => {
  if (path.value.includes("shape")) {
    patchShapeFactoryTest(isRestarting)
    return
  }
  if (path.value.includes("swipe")) {
    patchSwipeFactoryTest(isRestarting)
    return
  }
  if (path.value.includes("drive")) {
    patchDriveFactoryTest(isRestarting)
    return
  }
  if (path.value.includes("brain")) {
    patchBrainFactoryTest(isRestarting)
    return
  }
  if (path.value.includes("move")) {
    patchMoveFactoryTest()
    return
  }
}

const handleReset = () => {
  if (path.value.includes("shape")) {
    resetShape()
    return
  }
  if (path.value.includes("swipe")) {
    resetSwipe()
    return
  }
  if (path.value.includes("drive")) {
    resetDrive()
    return
  }
  if (path.value.includes("brain")) {
    resetBrain()
    return
  }
  if (path.value.includes("move")) {
    resetMove()
    return
  }
}
</script>

<template>
  <div class="reset-data">
    <div
      class="nav-button"
      @click="handleFactoryTest(false)"
      title="factory test"
    >
      ↪
    </div>
    <div
      class="nav-button"
      @click="handleFactoryTest(true)"
      title="factory restart"
    >
      ↪↪
    </div>
    <div class="nav-button" @click="handleReset" title="reset test">↩</div>
  </div>
</template>
